

import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SweetAlert } from 'src/app/Services/sweetalet.service';


@Component({
  selector: 'add-users',
  templateUrl: './add-users.component.html',
  // styles: ['./add-users.component.css']
})

export class AddUsersComponent {
  usersForm: FormGroup;
  matFormSize = '13px';
  formSubmit:boolean=false;
  public showBranch:boolean = false;
  selectedBranch: any[] = []
  shiftInformation: any = [];
  public fieldOptions=[{
    branch:[],
  }];
  public branchInformation: any=[];
  public userID;

  public headers:any=[];
  public userRestrictionData:any={}
  public tableData:any={};
  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public route: ActivatedRoute,
  
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.userID = params.params.userId;
      // console.log('params',params)
    });
  }
  ngOnInit():void {
    this.addUsersFormLoad();
    this.getBranchList();
    this.getUserRestictionList();
  }


  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if(res.data && res.data.length>0){
          res.data.filter((e)=>{
            let option={name:e.branchName,value:e.branchID};
            this.branchInformation.push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getUserRestictionList(){
    //api call to get user rest list
    let res={
      "Dashboard": {
          "name": "Dashboard",
          "checked":true,
          "menu1": {
            "Vehicle Information": {
                "name": "Vehicle Information",
                "checked":true
            },
            "Route Information": {
                "name": "Route Information",
                "checked":true
            },
            "Roster": {
                "name": "Roster",
                "checked":true,
                "menu2": {
                  "Map": {
                    "name": "Map",
                    "checked":true,
                  },
                  "Reports": {
                      "name": "Reports",
                      "checked":true,
                      "menu3": {
                        "Planned Trips": {
                          "name": "Planned Trips",
                          "checked":true,
                        },
                        "Trip Logs": {
                            "name": "Trip Logs",
                            "checked":true,
                        }
                      }
                  },
                  "Dispatch Viewer": {
                      "name": "Dispatch Viewer",
                      "checked":true,
                  },
                  "Roster Summary": {
                    "name": "Roster Summary",
                    "checked":true,
                  }
                }
            }
        }
      },
      "SOS Panel": {
        "name": "SOS Panel",
        "checked":true,
      },
      "Request": {
        "name": "Request",
        "checked":true
      },
      "Route / Rostering": {
          "name": "Route / Rostering",
          "checked":true,
          "menu1": {
              "Activities": {
                "name": "Activities",
                "checked":true,
              },
              "Manage": {
                "name": "Manage",
                "checked":true,
                "menu2": {
                  "Configuration": {
                    "name": "Configuration",
                    "checked":true,
                  },
                  "Roster":{
                    "name": "Roster",
                    "checked":true,
                  }
                }
              },
              "Regular": {
                  "name": "Regular",
                  "checked":true,
              },
              "Occasional": {
                  "name": "Occasional",
                  "checked":true,
              },
              "Open Booking": {
                  "name": "Open Booking",
                  "checked":true,
              }
          }
      },
      "Reports": {
        "name": "Reports",
        "checked":true,
        "menu1": {
            "SOS Report": {
                "name": "SOS Report",
                "checked":true,
            },
            "Over Speed Report": {
                "name": "Over Speed Report",
                "checked":true,
            },
            "Movement Report": {
                "name": "Movement Report",
                "checked":true,
            },
            "Halt Report": {
                "name": "Halt Report",
                "checked":true,
            },
            "Productivity Report on Trip": {
                "name": "Productivity Report on Trip",
                "checked":true,
            },
            "Offline Report": {
                "name": "Offline Report",
                "checked":true,
            },
            "Employee Booking Reports": {
                "name": "Employee Booking Reports",
                "checked":true,
            },
            "App Usage Report": {
                "name": "App Usage Report",
                "checked":true,
            },
            "Safe Drop Report": {
                "name": "Safe Drop Report",
                "checked":true,
            },
            "Attendance": {
                "name": "Attendance",
                "checked":true,
            },
            "Trip Report": {
              "name": "Trip Report",
              "checked":true,
            },
            "Complaint Ratings": {
                "name": "Complaint Ratings",
                "checked":true,
            },
            "Head Counts": {
              "name": "Head Counts",
              "checked":true,
            },
            "Geo Entry Exit": {
              "name": "Geo Entry Exit",
              "checked":true,
            },
            "Vehicle Audit Report": {
                "name": "Vehicle Audit Report",
                "checked":true,
            },
            "Vehicle Arriving Time": {
                "name": "Vehicle Arriving Time",
                "checked":true,
            },
            "Employee Boarding History": {
                "name": "Employee Boarding History",
                "checked":true,
            },
            "Seat Occupancy Report": {
                "name": "Seat Occupancy Report",
                "checked":true,
            },
            "Route Violation": {
                "name": "Route Violation",
                "checked":true,
            },
            "GPS Failure": {
                "name": "GPS Failure",
                "checked":true,
            }
        }
      },
      "Information": {
        "name": "Information",
        "checked":true,
        "menu1": {
            "Transport Vendors": {
                "name": "Transport Vendors",
                "checked":true,
            },
            "Organization": {
                "name": "Organization",
                "checked":true,
                "menu2":{
                  "Branch": {
                    "name": "Branch",
                    "checked":true,
                  },
                  "Shift Management": {
                      "name": "Shift Management",
                      "checked":true,
                  },
                  "Employees": {
                    "name": "Employees",
                    "checked":true,
                  },
                  "Guest": {
                      "name": "Guest",
                      "checked":true,
                  },
                  "Parking": {
                    "name": "Parking",
                    "checked":true,
                  },
                  "Notifications": {
                    "name": "Notifications",
                    "checked":true,
                  },
                  "Holidays": {
                      "name": "Holidays",
                      "checked":true,
                  },
                  "Escort": {
                      "name": "Escort",
                      "checked":true,
                  },
                  "Location": {
                      "name": "Location",
                      "checked":true,
                  },
                  "Global Settings": {
                      "name": "Global Settings",
                      "checked":true,
                  },
                  "Users": {
                      "name": "Users",
                      "checked":true,
                  }
                }
            },
            "Account": {
                "name": "Account",
                "checked":true,
            }
        }
      },
      "Support Desk": {
        "name": "Support Desk",
        "checked":true,
        "menu1": {
            "Announcement": {
                "name": "Announcement",
                "checked":true,
            },
            "Complaints": {
                "name": "Complaints",
                "checked":true,
            },
            "Feedback": {
                "name": "Feedback",
                "checked":true,
            },
            "Ticket": {
                "name": "Ticket",
                "checked":true,
            }
        }
      }
    }
    this.userRestrictionData=JSON.parse(JSON.stringify(res));
    this.tableData=JSON.parse(JSON.stringify(res));
    this.headers=Object.keys(this.tableData);
  }
  onChangeBranch(val) {
    this.selectedBranch = []
    this.shiftInformation.forEach((element, i) => {
      if (element.branch == val) {
        this.selectedBranch.push(element)
      }
    });
  }
  // addBranchOptions(){
  //   if(this.branchInformation && this.branchInformation.length>0){
  //     this.branchInformation.filter((e)=>{
  //       let option={name:e.branchName,value:e.branchID};
  //       this.fieldOptions[0].branch.push(option);
  //     });
  //   }
  // }
addUsersFormLoad() {
    this.usersForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      userEmail: new FormControl('', [Validators.required, Validators.email]),
      designation: new FormControl('', [Validators.required]),
      contactNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      isActive: new FormControl('',[Validators.required]),
      branch: new FormControl('', [Validators.required]),
    });
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.usersForm.controls[controlName].hasError(errorName);
  }

 
  
 
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  onSubmit() {
    this.formSubmit = true;
    // console.log(this.usersForm)
    if (this.usersForm.valid){
      const obj = {
        orgID: this.storage.get('userInfo').orgID,
        fieldMap:this.userRestrictionData,
        ...this.usersForm.value
      };
      obj.isActive=obj.isActive=='Active'?1:0;
      if(!Array.isArray(obj['branch'])) obj['branch'] = [obj['branch']];
      this.api.transportManagerUserCreate(obj).then((res: any) => {


        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/users/view-users'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  showNestedData(id){
    let btn=document.getElementById(id);
    if(btn.classList.contains('fa-chevron-down')){
        btn.classList.replace('fa-chevron-down','fa-chevron-up');
    }else{
        btn.classList.replace('fa-chevron-up','fa-chevron-down');
    }
  }
  selectModule(event,value,moduleIndex){
    this.tableData[value].checked=event;
    this.tableData[value].indeterminate=false;
    if(this.tableData[value].menu1){
      let sub1=this.tableData[value].menu1;
      let subModules1=Object.keys(sub1);
      for(let i=0;i<subModules1.length;i++){
        sub1[subModules1[i]].checked=event;
        sub1[subModules1[i]].indeterminate=false;

        if(sub1[subModules1[i]].menu2){
          let sub2=sub1[subModules1[i]].menu2;
          let subModules2=Object.keys(sub2);
          for(let j=0;j<subModules2.length;j++){
            sub2[subModules2[j]].checked=event;
            sub2[subModules2[j]].indeterminate=false;

            if(sub2[subModules2[j]].menu3){
              let sub3=sub2[subModules2[j]].menu3;
              let subModules3=Object.keys(sub3);
              for(let k=0;k<subModules3.length;k++){
                sub3[subModules3[k]].checked=event;
                sub3[subModules3[k]].indeterminate=false;
              }
            }
          }
        }
      }
    }
  }
  selectSubmodule1(event,selectedModule,selectedSubmodule1,moduleIndex,subModule1Index){
    this.tableData[selectedModule].menu1[selectedSubmodule1].checked=event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=false;
    // this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!event;
    if(this.tableData[selectedModule].menu1[selectedSubmodule1].menu2){
      let sub2=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
      let subModules2=Object.keys(sub2);
      for(let i=0;i<subModules2.length;i++){
        sub2[subModules2[i]].checked=event;
        sub2[subModules2[i]].indeterminate=false;

        if(sub2[subModules2[i]].menu3){
          let sub3=sub2[subModules2[i]].menu3;
          let subModules3=Object.keys(sub3);
          for(let j=0;j<subModules3.length;j++){
            sub3[subModules3[j]].checked=event;
            sub3[subModules3[j]].indeterminate=false;
          }
        }
      }
    }
    this.checkModuleIndeterminateOrChecked(event,selectedModule);
  }
  checkModuleIndeterminateOrChecked(event,selectedModule){
    let sub1=this.tableData[selectedModule].menu1;
    let subModules1=Object.keys(sub1);
    let isValid=true;
    for(let i=0;i<subModules1.length;i++){
      if((sub1[subModules1[i]].checked==false || sub1[subModules1[i]].checked==undefined || sub1[subModules1[i]].indeterminate==false)){
        isValid=false;
        break;
      }else{
        isValid=true;
      }
    }
    if(isValid){
      this.tableData[selectedModule].checked=isValid;
      this.tableData[selectedModule].indeterminate=!isValid;
    }else{
      let checkArr=[];
      let indeterArr=[];
      for(let i=0;i<subModules1.length;i++){
        if(sub1[subModules1[i]].checked){
          checkArr.push('checked');
        }else if(sub1[subModules1[i]].indeterminate){
          indeterArr.push('indeterminate');
        }
      }
      if(checkArr.length<=0 && indeterArr.length<=0){
        this.tableData[selectedModule].indeterminate=isValid;
        this.tableData[selectedModule].checked=isValid;
      }else if(checkArr.length==subModules1.length){
        this.tableData[selectedModule].checked=!isValid;
        this.tableData[selectedModule].indeterminate=isValid;
      }else if(indeterArr.length==subModules1.length){
        this.tableData[selectedModule].indeterminate=!isValid;
        this.tableData[selectedModule].checked=isValid;
      }else{
        this.tableData[selectedModule].indeterminate=!isValid;
        this.tableData[selectedModule].checked=isValid;
      }
    }
  }
  selectSubmodule2(event,selectedModule,selectedSubmodule1,selectedSubmodule2,moduleIndex,subModule1Index,subModule2Index){
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=false;
    if(this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3){
      let sub3=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
      let subModules3=Object.keys(sub3);
      for(let i=0;i<subModules3.length;i++){
        sub3[subModules3[i]].checked=event;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event,selectedModule,selectedSubmodule1);
  }
  checkSubmodule1IndeterminateOrChecked(event,selectedModule,selectedSubmodule1){
    let sub2=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
    let subModules2=Object.keys(sub2);
    let isValid=true;
    for(let i=0;i<subModules2.length;i++){
      if((sub2[subModules2[i]].checked==false || sub2[subModules2[i]].checked==undefined || sub2[subModules2[i]].indeterminate==false)){
        isValid=false;
        break;
      }else{
        isValid=true;
      }
    }
    if(isValid){
      this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!isValid;
    }else{
      let checkArr=[];
      let indeterArr=[];
      for(let i=0;i<subModules2.length;i++){
        if(sub2[subModules2[i]].checked){
          checkArr.push('checked');
        }else if(sub2[subModules2[i]].indeterminate){
          indeterArr.push('indeterminate');
        }
      }
      if(checkArr.length<=0 && indeterArr.length<=0){
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      }else if(checkArr.length==subModules2.length){
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=!isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=isValid;
      }else if(indeterArr.length==subModules2.length){
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      }else{
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      }
    }
    this.checkModuleIndeterminateOrChecked(event,selectedModule);
  }
  selectSubmodule3(event,selectedModule,selectedSubmodule1,selectedSubmodule2,selectedSubmodule3,moduleIndex,subModule1Index,subModule2Index,subModule3Index){
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].checked=event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].indeterminate=false;
    this.checkSubmodule2IndeterminateOrChecked(event,selectedModule,selectedSubmodule1,selectedSubmodule2,selectedSubmodule3)
  }

  checkSubmodule2IndeterminateOrChecked(event,selectedModule,selectedSubmodule1,selectedSubmodule2,selectedSubmodule3){
    let sub3=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
    let subModules3=Object.keys(sub3);
    let isValid=true;
    for(let i=0;i<subModules3.length;i++){
      if((!sub3[subModules3[i]].checked)){
        isValid=false;
        break;
      }else{
        isValid=true;
      }
    }
    if(isValid){
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=!isValid;
    }else{
      let arr=[];
      for(let i=0;i<subModules3.length;i++){
        arr.push(sub3[subModules3[i]].checked);
      }
      let value=arr.filter(e=>e==true);
      if(value.length<=0){
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=isValid;
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=isValid;
      }else{
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=!isValid;
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=isValid;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event,selectedModule,selectedSubmodule1);
  }
  openPopup(){
    let modal=document.getElementById('userRestrictionModal');
    if(modal.classList.contains('hide')){
      modal.classList.replace('hide','show');
      modal.style.display='block';
    }
  }
  closePopup(){
    this.tableData=JSON.parse(JSON.stringify(this.userRestrictionData));
    this.closeClick();
  }
  closeClick(){
    let modal=document.getElementById('userRestrictionModal');
    if(modal.classList.contains('show')){
      modal.classList.replace('show','hide');
      modal.style.display='none';
    }
  }
  onModalSubmit(){
    let isValid=false;
    let keys=Object.keys(this.tableData);
    for(let i=0;i<keys.length;i++){
      if(this.tableData[keys[i]].checked || this.tableData[keys[i]].indeterminate){
        isValid=true;
        break;
      }else{
        isValid=false;
      }
    }
    if(isValid){
      this.userRestrictionData=JSON.parse(JSON.stringify(this.tableData));
      this.closeClick();
    }else{
      this.swal.swalFunction('error', 'Failure', 'You must select atleast one module!', 2000);
    }

  }
}

